module.exports = __webpack_public_path__ + "static/img/Consulting.c36af91.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/Consulting.png
// module id = Kh7e
// module chunks = 0